const mEditionMenu = {
  mEditionMenu: {
    billing: {
      products: {
        subject: 'productos-de-vidroop',
        text: 'Productos de Vidroop',

        children: {
          create: {
            goBackText: 'volver atrás',
            subedition: 'crear-producto',
            text: 'Crear Producto'
          },

          edit: {
            goBackText: 'volver atrás',
            subedition: 'editar-producto',
            text: 'Editar Producto'
          }
        }
      },

      satellites: {
        subject: 'satelites-droops',
        text: 'Satélites (Droops)'
      },

      artificialIntelligence: {
        subject: 'inteligencia-artificial',
        text: 'Inteligencia Artificial'
      },

      artificialIntelligenceCosts: {
        subject: 'inteligencia-artificial-costos',
        // La url no cambia: los enlaces guardados siguen funcionando
        text: 'Ajustes de IA'
      },

      artificialIntelligenceUsage: {
        subject: 'inteligencia-artificial-consumo',
        text: 'Consumo de IA',

        children: {
          record: {
            goBackText: 'volver al listado',
            subedition: 'ficha',
            text: 'Ficha de consumo'
          }
        }
      },

      academyCharges: {
        subject: 'academia-cobros',
        text: 'Cobros por Academia',

        children: {
          invoice: {
            goBackText: 'volver atrás',
            subedition: 'comprobante',
            text: 'Comprobante'
          },

          invoicesHistory: {
            goBackText: 'volver atrás',
            subedition: 'historial-de-comprobantes',
            text: 'Historial de Comprobantes'
          },

          record: {
            subedition: 'registro',
            text: 'Detalle de Venta'
          }
        }
      },

      academySales: {
        subject: 'academia-ventas',
        text: 'Ventas por Academia',

        children: {
          invoice: {
            goBackText: 'volver atrás',
            subedition: 'comprobante',
            text: 'Comprobante'
          },

          invoicesHistory: {
            goBackText: 'volver atrás',
            subedition: 'historial-de-comprobantes',
            text: 'Historial de Comprobantes'
          },

          record: {
            subedition: 'registro',
            text: 'Detalle de Venta'
          }
        }
      },

      academyProducts: {
        subject: 'academia-productos',
        text: 'Productos por Academia',

        children: {
          detail: {
            subedition: 'detalle',
            text: 'Detalle del producto'
          }
        }
      },

      academyProyects: {
        subject: 'academia-proyectos',
        text: 'Proyectos por Academia',

        children: {
          details: {
            subedition: 'detalles',
            text: 'Detalle del proyecto'
          }
        }
      },

      academyClients: {
        subject: 'academia-clientes',
        text: 'Clientes por Academia',

        children: {
          sales: {
            subedition: 'ventas',
            text: 'Ventas del Cliente'
          }
        }
      },

      academyUsers: {
        subject: 'academia-usuarios',
        text: 'Usuarios por Academia',

        children: {
          profile: {
            subedition: 'perfil',
            text: 'Perfil'
          }
        }
      },

      academyBilling: {
        subject: 'academia-facturacion',
        text: 'Facturación por Academias'
      },

      studentTracking: {
        subject: 'trazabilidad-alumnos',
        text: 'Trazabilidad de Alumnos',

        children: {
          detail: {
            goBackText: 'volver atrás',
            subedition: 'detalle',
            text: 'Detalle del Alumno'
          }
        }
      },

      salesData: {
        subject: 'puntos-de-venta',
        text: 'Puntos de venta',

        children: {
          create: {
            goBackText: 'volver atrás',
            subedition: 'crear-punto',
            text: 'Crear Punto de Venta'
          },

          edit: {
            goBackText: 'volver atrás',
            subedition: 'editar-punto',
            text: 'Editar Punto de Venta'
          }
        }
      },

      academies: {
        subject: 'academias',
        text: 'Todas las Academias',

        children: {
          data: {
            subedition: 'datos',
            text: 'Datos de Academia'
          }
        }
      },

      academyMigration: {
        subject: 'migracion',
        text: 'Migración de Academia'
      },

      modifyPassword: {
        subject: 'modificar-contraseña',
        text: 'Modificar Contraseña'
      },

      modifyUser: {
        subject: 'modificar-usuario',
        text: 'Modificar Usuario'
      },

      usersMonitoring: {
        subject: 'monitoreo-usuario',
        text: 'Monitoreo de Usuario'
      }

    }
  }
}

export default mEditionMenu
